import {Order} from './Order';
import {OrderItem} from './OrderItem';
import {OrderItemProduct} from './OrderItemProduct';
import {Option} from './Option';
import {Property} from './Property';
import {TotalCost} from './TotalCost';
import {OptionCost} from './OptionCost';
import {Product} from './Product';
import {FabricCollection} from './FabricCollection';
import {Fabric} from './Fabric';
import {FabricColor} from './FabricColor';
import {ProductCost} from './ProductCost';

export class OrderItemOption {
  order: Order;
  orderItem: OrderItem;
  option: Option;
  options: Option[];
  urbanOption: Option;
  optionsAppliedCount: number;
  property: Property;
  product: Product;
  propertyAmount: any;
  productAmount: number;
  dealerPrice: number;
  customerPrice: number;
  firstParent?: number;
  parent?: number;
  totalCost = new TotalCost();
  cost = new ProductCost();
  fabric: number | Fabric;
  fabricColor: number | FabricColor;
  fabricCollection?: number ;
  random?: number ;
  position: any;
  parentPosition: any;
}
